import React from 'react';
import {
  Box,
  IconButton
} from '@mui/material';
import '../../../modules/components/layer02/CustomChart/CustomChart.css';
import { CustomChart } from 'modules';
import { Comment } from '@mui/icons-material';


// need to figure out how to type these...

export type ChartThemeActivityProps = {};

export const ChartThemeActivity = (props: ChartThemeActivityProps) => {
  const data = [
    {
      name: '1M',
      rate: '5.47'
    },
    {
      name: '2M',
      rate: '5.50'
    },
    {
      name: '3M',
      rate: '5.46'
    },
    {
      name: '4M',
      rate: '5.51'
    },
    {
      name: '6M',
      rate: '5.43'
    },
    {
      name: '1Y',
      rate: '5.21'
    },
    {
      name: '2Y',
      rate: '4.96'
    },
    {
      name: '3Y',
      rate: '4.79'
    },
    {
      name: '5Y',
      rate: '4.64'
    },
    {
      name: '7Y',
      rate: '4.64'
    },
    {
      name: '10Y',
      rate: '4.63'
    },
    {
      name: '20Y',
      rate: '4.85'
    },
    {
      name: '30Y',
      rate: '4.74'
    }

  ];
  return (
    <Box display='flex' padding='1.5rem' columnGap='1.5rem'>
      <CustomChart.FC type='AREA' data={data} title='US Treasure Yields' />
      <CustomChart.FC type='BAR' data={data} title='Gross Domestic Product'>
        <IconButton>
          <Comment />
        </IconButton>
      </CustomChart.FC>


    </Box>

  );
};
